module.exports = __webpack_public_path__ + "static/media/logoInterviewx.db8b08e5.svg";